import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from 'rxjs';

import { PerimetreAntenne } from '../entities/perimetre-antenne.entity';
import { TransfertPerimetreOrder } from '../entities/transfert-perimetre-order.entity';
import { TypeResponsabilite } from '../entities/type-responsabilite.entity';

@Injectable({ providedIn: 'root' })
export class PerimetresService {
	private path: string;

	constructor( //
		@Inject(HttpClient) public httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: PerimetresService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	public listPerimetresForUser(userId: number | 'current', type: TypeResponsabilite,  antenneId: number | null): Observable<PerimetreAntenne[]> {
		let url = this.path + 'users/' + userId + '/perimetres/' + type;
		if (antenneId != null) {
			url += '?antenne=' + antenneId;
		}
		return this.httpClient //
			.get<PerimetreAntenne[]>(url) //
		;
	}
	
	public registerResponsability(command: TransfertPerimetreOrder): Observable<any> {
		let url = this.path + 'perimetres/save-orders';
		let result = this.httpClient.post<any>(url, command);
		return result;
	};
}